import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Card } from 'antd';
import { v4 as uuid } from 'uuid';

import { FiltersDrawer } from '../../../../containers/drawer/FiltersDrawer';
import { TopLendersTable } from './Components/TopLendersTable';
import { useGetTopLenders } from '../../../../queries/TopLendersReport';
import { rangeOptions } from '../../../TopBuyersReportPage/constants';
import { ViewPanel } from '../../../../containers/view/ViewPanel';

import './index.scss';

export const TopLendersReport = () => {
  const [isMounted, setIsMounted] = useState(false);
  const [selectedMonths, setSelectedMonths] = useState(3);
  const [createViewMode, setCreateViewMode] = useState(false);
  const { appliedFilters } = useSelector(
    ({ FiltersReducer }) => FiltersReducer,
  );

  useEffect(() => {
    if (!isMounted) {
      setIsMounted(true);
    }
  }, []);

  const { data: topLendersData, isLoading, isError } = useGetTopLenders({
    selectedMonthRange: selectedMonths,
    appliedFilters,
    isMounted,
  });
  const handleRangeChange = (value) => {
    setSelectedMonths(value);
  };

  return (
    <div className="top-lenders-report-page">
      <div className="range-container">
        {rangeOptions.map((option) => (
          <Card
            key={uuid()}
            className={`range-card ${
              selectedMonths === option.value ? 'active' : ''
            }`}
            onClick={() => handleRangeChange(option.value)}
          >
            {option.label}
          </Card>
        ))}
      </div>
      <ViewPanel />
      <Card
        title="Top lenders by market"
        className="top-lenders-report-table-container"
      >
        <TopLendersTable
          isLoading={isLoading}
          isError={isError}
          data={topLendersData}
        />
      </Card>
      <FiltersDrawer
        createViewMode={createViewMode}
        setCreateViewMode={setCreateViewMode}
      />
    </div>
  );
};
